import { env } from '~/config/env';

export function getExamName() {
  switch (env.VITE_APP) {
    case 'usmle':
      return 'USMLE® Step 1';
    case 'ems':
      return 'NREMT® Paramedic Exam';
  }
}
